<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

const properties = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <tbody :class="cn('atabix-table-body', properties.class)">
    <slot />
  </tbody>
</template>

<style lang="scss">
.atabix-table-body {
  tr:last-child {
    @apply border-0;
  }
}

.atabix-table-wrapper--mobile {
  .atabix-table-body {
    @apply p-4;
    @apply flex flex-col gap-y-4;
  }
}
</style>
